(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dizayni-collection-universelle"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.dzcReady || !('AbortController' in window)) return;
    root.dataset.dzcReady = 'true';
    const listeners = new AbortController();
    const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, {...options, signal: listeners.signal});
    const openButton = root.querySelector('[data-dzc-open]');
    let filterOverflow = '';
    const closeFilters = () => {
      if (!root.classList.contains('is-filter-open')) return;
      root.classList.remove('is-filter-open');
      document.documentElement.style.overflow = filterOverflow;
      openButton?.focus({preventScroll:true});
    };
    listen(openButton, 'click', () => {
      filterOverflow = document.documentElement.style.overflow;
      root.classList.add('is-filter-open');
      document.documentElement.style.overflow = 'hidden';
    });
    root.querySelectorAll('[data-dzc-close]').forEach(button => listen(button, 'click', closeFilters));
    listen(document, 'keydown', event => { if (event.key === 'Escape') closeFilters(); });
    root.querySelectorAll('[data-dzc-sort] select').forEach(select => listen(select, 'change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.hash = '';
      location.assign(url.href);
    }));
    const grid = root.querySelector('[data-dzc-grid]');
    const pager = root.querySelector('[data-dzc-pager]');
    if (!grid || !pager) return;
    const link = pager.querySelector('[data-dzc-load]');
    const fallback = pager.querySelector('[data-dzc-fallback]');
    const status = pager.querySelector('[data-dzc-status]');
    const spinner = pager.querySelector('[data-dzc-spinner]');
    const count = pager.querySelector('[data-dzc-count]');
    const sectionId = root.dataset.sectionId;
    const maxAuto = Math.max(0, Number(root.dataset.autoBatches) || 0);
    const pageURL = input => {
      const url = new URL(input, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Invalid collection URL');
      url.searchParams.delete('section_id');
      url.hash = '';
      return url;
    };
    const base = pageURL(location.href).href;
    let next = pager.dataset.nextUrl ? pageURL(pager.dataset.nextUrl).href : '';
    let busy = false, restoring = false, manualOnly = maxAuto === 0, autoLoads = 0;
    let observer, request, suspended = false, destroyed = false;
    const pages = [];
    const loaded = new Set([base]);
    const cardIDs = new Set(Array.from(grid.children, card => card.dataset.productId));
    let entryId;
    try {
      const state = history.state && typeof history.state === 'object' ? history.state : {};
      const entries = state.dzcInfiniteEntries || {};
      entryId = entries[sectionId] || (crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random());
      if (!entries[sectionId]) history.replaceState({...state, dzcInfiniteEntries:{...entries, [sectionId]:entryId}}, '', location.href);
    } catch { entryId = base; }
    const storageKey = 'dzc-scroll-v1:' + sectionId + ':' + entryId;
    const save = () => {
      if (restoring || destroyed) return;
      const cards = Array.from(grid.children);
      const anchor = cards.find(card => card.getBoundingClientRect().bottom > 0);
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({base, pages, autoLoads, manualOnly, y:window.scrollY, anchor:anchor?.dataset.productId || '', offset:anchor?.getBoundingClientRect().top || 0, at:Date.now()}));
      } catch {}
    };
    const update = () => {
      count.textContent = String(grid.children.length);
      grid.setAttribute('aria-busy', String(busy || restoring));
      spinner.hidden = !(busy || restoring);
      link.hidden = !next;
      link.setAttribute('aria-disabled', String(busy || restoring));
      if (next) { link.href = next; fallback.href = next; }
      if (!next && !busy && !restoring) status.textContent = pager.dataset.complete;
    };
    const load = async (url, mode = 'manual') => {
      if (busy || suspended || destroyed || !url || loaded.has(url)) return false;
      busy = true;
      observer?.disconnect();
      fallback.hidden = true;
      status.textContent = restoring ? pager.dataset.restoring : pager.dataset.loading;
      update();
      request = new AbortController();
      const timer = setTimeout(() => request.abort(), 15000);
      try {
        const target = pageURL(url);
        target.searchParams.set('section_id', sectionId);
        const response = await fetch(target.href, {credentials:'same-origin', signal:request.signal, headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Section request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingRoot = doc.getElementById(root.id);
        const incomingGrid = incomingRoot?.querySelector('[data-dzc-grid]');
        const incomingPager = incomingRoot?.querySelector('[data-dzc-pager]');
        if (!incomingGrid || !incomingPager || !incomingGrid.children.length) throw new Error('Missing collection results');
        const following = incomingPager.dataset.nextUrl ? pageURL(incomingPager.dataset.nextUrl).href : '';
        if (following && (following === url || loaded.has(following))) throw new Error('Repeated collection page');
        const cards = Array.from(incomingGrid.children).filter(card => card.matches('.dzc-card') && card.dataset.productId && !cardIDs.has(card.dataset.productId));
        if (!cards.length) throw new Error('No new products');
        if (suspended || destroyed || request.signal.aborted) return false;
        const fragment = document.createDocumentFragment();
        for (const card of cards) {
          card.querySelectorAll('script').forEach(script => script.remove());
          cardIDs.add(card.dataset.productId);
          fragment.appendChild(document.importNode(card, true));
        }
        grid.appendChild(fragment);
        loaded.add(url);
        pages.push(url);
        next = following;
        pager.dataset.nextUrl = next;
        if (mode === 'auto') autoLoads += 1;
        if (autoLoads >= maxAuto) manualOnly = true;
        status.textContent = next ? '' : pager.dataset.complete;
        if (mode === 'manual') {
          const firstLink = grid.children[grid.children.length - cards.length]?.querySelector('a');
          firstLink?.focus({preventScroll:true});
        }
        save();
        return true;
      } catch {
        if (!suspended && !destroyed) {
          manualOnly = true;
          status.textContent = pager.dataset.error;
          fallback.hidden = false;
          fallback.href = pageURL(url).href;
        }
        return false;
      } finally {
        clearTimeout(timer);
        busy = false;
        request = null;
        update();
        if (!suspended && !destroyed && !restoring && !manualOnly && next) observer?.observe(pager);
      }
    };
    listen(link, 'click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (!restoring) load(next);
    });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !restoring && !busy && !manualOnly && !suspended && next) load(next, 'auto');
      }, {rootMargin:'0px 0px 320px 0px'});
    }
    listen(root, 'click', event => { if (event.target.closest('.dzc-card a')) save(); }, {capture:true});
    listen(window, 'pagehide', () => { save(); suspended = true; request?.abort(); observer?.disconnect(); });
    listen(window, 'pageshow', event => {
      if (event.persisted) {
        suspended = false;
        update();
        if (!restoring && !manualOnly && next) observer?.observe(pager);
      }
    });
    listen(document, 'shopify:section:unload', event => {
      if (event.target.contains(root)) { save(); destroyed = true; request?.abort(); observer?.disconnect(); closeFilters(); listeners.abort(); }
    });
    const restore = async () => {
      let snapshot;
      try { snapshot = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
      const navigation = performance.getEntriesByType('navigation')[0]?.type;
      if (!snapshot || snapshot.base !== base || !['back_forward','reload'].includes(navigation) || Date.now()-snapshot.at > 30*60*1000 || !Array.isArray(snapshot.pages)) return;
      restoring = true;
      let interrupted = false;
      const cancel = () => { interrupted = true; };
      const keyCancel = event => { if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key)) cancel(); };
      window.addEventListener('wheel', cancel, {passive:true});
      window.addEventListener('touchstart', cancel, {passive:true});
      window.addEventListener('keydown', keyCancel);
      const oldRestoration = history.scrollRestoration;
      history.scrollRestoration = 'manual';
      status.textContent = pager.dataset.restoring;
      update();
      let complete = true;
      try {
        for (const recorded of snapshot.pages) {
          if (interrupted || suspended || destroyed) { complete = false; break; }
          const normalized = pageURL(recorded).href;
          if (normalized !== next || !await load(normalized, 'restore')) { complete = false; break; }
        }
        autoLoads = Number(snapshot.autoLoads) || 0;
        manualOnly = Boolean(snapshot.manualOnly) || !complete || autoLoads >= maxAuto;
        if (complete && !interrupted && !suspended && !destroyed) {
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          if (!interrupted) {
            const anchor = Array.from(grid.children).find(card => card.dataset.productId === snapshot.anchor);
            const y = anchor ? window.scrollY + anchor.getBoundingClientRect().top - snapshot.offset : snapshot.y;
            window.scrollTo({top:Math.max(0, Number(y) || 0), behavior:'instant'});
          }
        }
      } catch { manualOnly = true; }
      finally {
        window.removeEventListener('wheel', cancel);
        window.removeEventListener('touchstart', cancel);
        window.removeEventListener('keydown', keyCancel);
        history.scrollRestoration = oldRestoration;
        restoring = false;
        if (complete || interrupted) status.textContent = next ? '' : pager.dataset.complete;
        else if (status.textContent === pager.dataset.restoring) status.textContent = pager.dataset.error;
        update();
        save();
      }
    };
    update();
    restore().finally(() => {
      if (!suspended && !destroyed && !manualOnly && next) observer?.observe(pager);
    });
  };
  const boot = () => document.querySelectorAll('[data-dzc-infinite]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

(() => {
  if (window.dzcAutoImageFitInstalled) return;
  window.dzcAutoImageFitInstalled = true;
  const watched = new WeakSet();
  const selector = '.dzc .dzc-card__img--2';
  const isWhiteBorder = (pixels, size) => {
    const white = (x, y) => {
      const i = (y * size + x) * 4;
      if (pixels[i + 3] < 20) return true;
      const rgb = [pixels[i], pixels[i + 1], pixels[i + 2]];
      return Math.min(...rgb) >= 242 && Math.max(...rgb) - Math.min(...rgb) <= 12;
    };
    const edges = [0, 0, 0, 0];
    for (let n = 0; n < size; n++) {
      edges[0] += white(n, 0);
      edges[1] += white(n, size - 1);
      edges[2] += white(0, n);
      edges[3] += white(size - 1, n);
    }
    return edges.every(count => count / size >= 0.92);
  };
  const analyze = image => {
    if (!image.naturalWidth) return;
    try {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = 64;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;
      context.drawImage(image, 0, 0, 64, 64);
      image.dataset.dzcWhiteBackground = String(isWhiteBorder(context.getImageData(0, 0, 64, 64).data, 64));
    } catch {
      image.dataset.dzcWhiteBackground = 'false';
    }
  };
  const watch = image => {
    if (watched.has(image)) return;
    watched.add(image);
    image.addEventListener('load', () => analyze(image));
    if (image.complete && image.naturalWidth) analyze(image);
  };
  const scan = node => {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.(selector)) watch(node);
    node.querySelectorAll(selector).forEach(watch);
  };
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) scan(node);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dizayni-exit-popup"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-dz-circle]').forEach(dialog => {
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const editor = dialog.dataset.editor === 'true';
    const mode = new URLSearchParams(location.search).get('dizayni_popup');
    const preview = mode === '1' || (editor && dialog.dataset.preview === 'true');
    const exitTest = mode === 'exit-test';
    const testing = preview || exitTest;
    const key = 'dizayni-circle-v1';
    const get = (storage, name) => { try { return storage.getItem(name); } catch { return null; } };
    const put = (storage, name, value) => { try { storage.setItem(name, value); } catch {} };
    let local, session;
    try { local = window.localStorage; } catch {}
    try { session = window.sessionStorage; } catch {}
    let shown = false, previousOverflow = '', previousFocus;
    let started = Number(get(session, key + '-start'));
    if (!started) { started = Date.now(); put(session, key + '-start', String(started)); }
    const finePointer = matchMedia('(any-hover: hover) and (any-pointer: fine)');
    let mouseSeen = false, wasInside = false, lastY = null;
    const desktop = () => finePointer.matches || mouseSeen;
    const visible = el => {
      if (el.closest('[hidden], [aria-hidden="true"]')) return false;
      const style = getComputedStyle(el), rect = el.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
    };
    const blocked = () => {
      if (document.hidden) return true;
      return [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, dialog[open], [aria-modal="true"]')].some(el => el !== dialog && !dialog.contains(el) && visible(el));
    };
    const suppressed = () => dialog.dataset.subscribed === 'true' || get(local, key + '-subscribed') === 'true' || Number(get(local, key + '-until')) > Date.now() || get(session, key + '-shown') === 'true';
    const show = (force = false) => {
      if (dialog.open || blocked() || (!force && (shown || (!exitTest && suppressed()) || editor))) return false;
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      shown = true;
      if (!testing) put(session, key + '-shown', 'true');
      dialog.querySelector('[data-dz-close]').focus({preventScroll:true});
      return true;
    };
    dialog.querySelector('[data-dz-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close();} });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      if (!testing) put(local, key + '-until', String(Date.now() + 7*24*60*60*1000));
      previousFocus?.focus?.({preventScroll:true});
    });
    const form = dialog.querySelector('form');
    form?.addEventListener('submit', event => {
      if (testing) { event.preventDefault(); return; }
      if (!form.checkValidity()) return;
      put(session, key + '-pending', String(Date.now()));
    });
    const pending = Number(get(session, key + '-pending'));
    const returned = pending > 0 && Date.now() - pending < 30*60*1000;
    let responsePending = returned && !!dialog.querySelector('[data-dz-success], [data-dz-error]');
    if (responsePending && dialog.querySelector('[data-dz-success]')) put(local, key + '-subscribed', 'true');
    const check = () => {
      if (!dialog.isConnected) { clearInterval(timer); document.removeEventListener('mouseout', exit, true); document.documentElement.removeEventListener('mouseleave', exit, true); document.removeEventListener('pointermove', approach, true); return; }
      if (preview || responsePending) {
        if (shown) return;
        if (show(true) && responsePending) { responsePending = false; put(session, key + '-pending', '0'); }
        return;
      }
      if (desktop() || shown || (!exitTest && suppressed()) || Date.now()-started < 40000) return;
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      if (distance > 0 && window.scrollY / distance >= .5) show();
    };
    const approach = event => {
      if (event.pointerType !== 'mouse') return;
      mouseSeen = true;
      if (event.clientY > 80) wasInside = true;
      const movingUp = lastY !== null && event.clientY < lastY;
      lastY = event.clientY;
      if (wasInside && movingUp && event.clientY <= 14 && Date.now()-started >= 15000) show();
    };
    const exit = event => {
      if (desktop() && !event.relatedTarget && event.clientY <= 14 && Date.now()-started >= 15000) show();
    };
    document.addEventListener('pointermove', approach, {capture:true, passive:true});
    document.addEventListener('mouseout', exit, true);
    document.documentElement.addEventListener('mouseleave', exit, true);
    const timer = setInterval(check, 1000);
    check();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dizayni-sur-mesure"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('dizayni-sur-mesure')) {
  customElements.define('dizayni-sur-mesure', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('dzsm-enhanced');
      const panels = [...this.querySelectorAll('[data-room-panel]')];
      const buttons = [...this.querySelectorAll('[data-room-button]')];
      const tabs = this.querySelector('[data-room-tabs]');
      const choose = id => {
        panels.forEach(panel => { panel.hidden = panel.dataset.roomPanel !== id; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.roomButton === id)));
      };
      if (panels.length) { choose(panels[0].dataset.roomPanel); if (tabs) tabs.hidden = panels.length < 2; }
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.roomButton)));
      this.querySelectorAll('.dzsm-range').forEach(range => {
        range.hidden = false;
        range.addEventListener('input', () => range.closest('.dzsm-compare').style.setProperty('--split', range.value + '%'));
      });
      const request = this.querySelector('[data-project-request]');
      const form = request.querySelector('form');
      const result = request.querySelector('[data-form-result]');
      const isReturn = Boolean(result) || location.hash === '#' + form.id || new URLSearchParams(location.search).get('contact_posted') === 'true';
      request.hidden = !isReturn && !(window.Shopify && Shopify.designMode);
      this.querySelectorAll('[data-project-start]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        request.hidden = false;
        const select = request.querySelector('[data-project-plan]');
        if (select) select.value = link.dataset.plan || '';
        request.scrollIntoView({block:'start',behavior:'auto'});
        const target = request.querySelector('input:not([type="hidden"]), [data-form-result]');
        if (target) target.focus({preventScroll:true});
      }));
      if (result) { result.focus({preventScroll:true}); request.scrollIntoView({block:'start',behavior:'auto'}); }
      this.addEventListener('shopify:block:select', event => {
        const panel = panels.find(item => item.dataset.roomPanel === event.detail.blockId);
        if (panel) choose(panel.dataset.roomPanel);
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
